module.exports = __webpack_public_path__ + "static/gender_card_img3@2x-e3ff18bec200ebe2e4e400b51f7d3c9f.jpg";